























































































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';

// External variables
import { materialTemplateOptionalForm } from '@/constants/form/materialTemplateForm';
import {
  authorityInvalidMessage,
  authorityValidMessage,
  ExceptionHeaderItem,
  MaterialTemplateListDisplayButtonDisabledItems,
  MaterialtemplateCommodityMasterDatas,
  MaterialtemplateListDisplayInputFormatItemsPartsList,
  PartsListHeaders,
  registerFinishAction,
  registerFinishText,
  toolTipsMessage,
  MaterialTemplateListDisplayButtonItems
} from '@/constants/materialtemplate/materialtemplate';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  GetInputFieldsActons
} from '@/services/hexabase/types';

// Model
import MaterialTemplate from '@/models/materialTemplateModel';

// External component
import Header from '@/components/common/modules/Header.vue';
import Icon from '@/components/common/elements/Icon.vue';
import CreateBasicInfo from '@/components/sample/detail/CreateBasicInfo.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SampleAction from '@/components/sample/detail/SampleAction.vue';
import ListDisplay from '@/components/common/modules/ListDisplay.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import { DateTime } from 'luxon';
import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';

interface SelectOptions {
  option_id: string;
  sort_id: 0;
  value: string;
  enabled: true;
  color: string;
  display_id: string;
  text: string;
}
/** リスト用 */
interface RegistMaterialTempleteData {
  No: number;
  id: number;
  quantity: number;
  refitem: string;
  refitem_code: string;
  refmodel_number: string;
  refrev_no: number;
  material_id: string;
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  unit_lower_limit?: number;
  unit_upper_limit?: number;
  edit_price_flag?: string;
  edit_material_flag?: string;
}
/** 登録用 */
interface RegistMaterialTempleteExec {
  /** 参照元基本のID */
  materialtemplate_id: string;
  /** 数量 */
  quantity: number;
  /** 参照品名 */
  ref_item: string;
  /** 参照品番 */
  ref_item_code: string;
  /** 参照型番 */
  ref_model_number: string;
  /** 参照リビジョン */
  ref_rev_no: number;
  /** 参照元構成表マスタ */
  material_id: string;
  /** 参照元構成表マスタ */
  sort_no: number;
  edit_price_flag?: string;
  edit_material_flag?: string;
  /** 数量 下限、上限 */
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  /** 単価 下限、上限 */
  unit_lower_limit?: number;
  unit_upper_limit?: number;
}

Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    Header,
    Icon,
    CreateBasicInfo,
    SideMenu,
    PageInfoBar,
    SampleAction,
    ListDisplay,
    TransitionDialog,
    Dialog,
    HeaderPanel,
    ExecAction,
    MasterSelectMultiSetControl
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class MaterialTemplateRegister extends Vue {
  private projectId = hexabaseState.applicationId;
  private materialTemplate = new MaterialTemplate();
  // private headerData = { cols: {}, datas: {} as { [k: string]: any } };
  private prevRoute: any = null;

  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';

  // dbID格納プロパティ
  private mainDsId = '';
  private subDsId = '';

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  /** リスト */
  private RegistMaterialTempleteDataList: Array<RegistMaterialTempleteData> = [];

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private registerText = this.materialTemplate.deepCopy(registerFinishText);
  private buttons: Array<{
    [k: string]: string | number | { [k: string]: { [k: string]: string } };
  }> = this.materialTemplate.deepCopy(registerFinishAction);

  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  // マスター参照系の変数
  // 商材
  private masterCommoditySelectData: any = [];
  // 商材マスタ参照選択のバリデーションルール
  private commodityRules = 'required';

  // ステータス
  private displayStatus = '';

  private registAuthority = false;
  private guideMessage = '';

  private basicNewAction: any = [];

  private ActionButtonType = 'register_cancel';
  private toolTipsText = '';
  private isExecDialog = false;
  private execDialogMessage =
    '既存のテンプレートと名称が重複しています。詳細画面で更新を行いますか？';
  private execDialogTitle = '登録確認';

  private masterSelectDataCommodity: any = {
    columns: MaterialtemplateCommodityMasterDatas.Columns,
    body: this.masterCommoditySelectData,
    dialogTitle: '商材マスタ',
    outPutData: [
      { label: 'サービス種別', name: 'service_type_id', isReadOnly: true, isDisabled: false },
      { label: '商材', name: 'commodity', isReadOnly: true, isDisabled: false },
      { label: '商材仕入先', name: 'supplier_id', isReadOnly: true, isDisabled: false }
    ],
    searchLargeItemData: {
      findItemName: 'service_type_id',
      setItemValue: 'service_type_id',
      setItemText: 'service_type_id'
    },
    searchSmallItemData: {
      findItemName: 'commodity',
      setItemValue: 'commodity',
      setItemText: 'commodity'
    },
    title: '商材マスタ',
    labelName: ['サービス種別', '商材', '商材仕入先'],
    rules: this.commodityRules,
    isBtnVisible: true,
    isShow: true,
    isLoadingFlag: false,
    isParentDialogControlFlag: true
  };

  private partsListColumn: any = [];
  private partsListData: any = [];

  private partsList = {
    listName: '部品一覧',
    formOutputButtonName: '',
    isAddItemButtonFlag: false,
    tableParameters: {
      isDisabledFormOutputButton: false,
      isDisabledNoteEdit: true,
      buttonItems: MaterialTemplateListDisplayButtonDisabledItems,
      inputItems: MaterialtemplateListDisplayInputFormatItemsPartsList,
      columns: this.partsListColumn,
      body: this.partsListData,
      tableText: '商材が選択されていません'
    },
    subHeadersScrollWidthData: 0
  };

  /** 重複から詳細に飛ぶために使う */
  private isDuplicateId = '';

  private exceptionHeaderItem = ExceptionHeaderItem;

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // 管理者権限判定
      if (!userState.isAdmin) {
        this.setError(this.materialTemplate.getDefaultRoleErrorMessage());
        return;
      }

      this.mainDsId = hexabaseState.datastoreIds['構成表テンプレート'];
      this.subDsId = hexabaseState.datastoreIds['構成表テンプレート明細'];
      // tooltips情報を後設定出来るよう修正
      this.toolTipsText = '';
      this.toolTipsText = this.materialTemplate.deepCopy(
        toolTipsMessage['materialTemplate_CreateBasicInfoPlusInfo']
      );
      // ステート表示表示は行わない
      this.displayStatus = '';

      // 入力フィールド情報を取得
      await Promise.all([
        this.materialTemplate.getMasterData('', ''),
        this.materialTemplate.getFieldsData(this.projectId, this.subDsId).then(response => {
          this.setHeaderListColumn(
            response,
            PartsListHeaders,
            this.partsList.tableParameters,
            'columns',
            this.exceptionHeaderItem
          );
        })
      ]);

      this.masterData = this.materialTemplate.getMaster();

      const commodityItemResult = this.masterData['m_commodity'].body;
      for (const key in commodityItemResult) {
        this.masterCommoditySelectData.push(commodityItemResult[key]);
      }

      await this.getBasicFields();

      // 権限を取得する
      // デフォルトの新規登録アクション以外を取得できていないなら登録権限を持たない
      this.registAuthority = this.basicNewAction !== undefined ? true : false;
      this.guideMessage = this.registAuthority ? authorityValidMessage : authorityInvalidMessage;
    } catch (e) {
      if (e instanceof Error) {
        console.log(e.message);
        this.setError(e.message);
      } else if (typeof e === 'string') {
        console.log(e);
        this.setError(e);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const newAction = await this.materialTemplate.getNewActionList(this.mainDsId).then(data => {
        return data;
      });
      this.basicNewAction = newAction.actions.find(v => v.display_id === 'CreateItem');
      const [inputFields, fieldsData] = await Promise.all([
        this.materialTemplate.getFieldsByActionId(this.mainDsId, newAction.actions[0].action_id),
        this.materialTemplate.makeFieldsList(this.projectId, this.mainDsId)
      ]);

      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = this.materialTemplate
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.materialTemplate.deepCopy(materialTemplateOptionalForm),
          true
        )
        .map(field => this.materialTemplate.inputRestriction(field, inputFields))
        .map(field => {
          // フィールドの初期値・登録データ初期値
          this.registData.item = {
            ...this.registData.item,
            ...this.materialTemplate.setRregistData(field, inputFields)
          };
          return this.materialTemplate.setSelected(field, inputFields);
        })
        .map(v => {
          if (v.registProps !== undefined && v.registProps!['setting'] !== undefined) {
            const stateKey = v.registProps!['setting']!.key!;
            switch (stateKey) {
              case 'getUserDepartmentId': {
                v.props!.value = { item_id: userState.getUserDepartmentId };
                break;
              }
              case 'getUserEmployeeId': {
                v.props!.value = { item_id: userState.getUserEmployeeId };
                break;
              }
              case 'getOrderApplicationDate': {
                v.props!.value = DateTime.local().toString();
                break;
              }
              default:
                break;
            }
          }
          return v;
        });
      this.basicFieldCols = this.materialTemplate.getGridStatus(data);
      this.basicFieldsData = (await this.modifyFields(this.mainDsId, data, inputFields)) as Array<
        FieldChildrenProp
      >;
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }

  /**
   * ヘッダ情報フィールド定義作成
   */
  private async getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.materialTemplate.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  /**
   * ヘッダ情報フィールドデータ作成
   */
  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    inputFields: GetInputFieldsActons
  ) {
    data = this.addInputRules(data as Array<FieldChildrenProp>, inputFields.action_field_settings);
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        // eslint-disable-next-line prefer-const
        let row = fieldSetting[field.field_id];
        if (row.update && !field.props!.isDisabled) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  /**
   * フィールド情報を取得して、指定の場所に設定する
   * @module setHeaderListColumn
   */
  private setHeaderListColumn(
    inputFields: any,
    baseListColumn: any,
    setItem: any,
    setArea: string,
    exceptionColumnItem: Array<string> = []
  ) {
    const listColumn = JSON.parse(JSON.stringify(baseListColumn));
    // header内容の書き換え
    this.listHeaderCreate(inputFields, listColumn, exceptionColumnItem);
    this.$set(setItem, setArea, listColumn);
  }

  /**
   * フィールド情報とカラム情報を突き合わせて、不要なカラムを削除
   * @module listHeaderCreate
   */
  private listHeaderCreate(
    listInputField: any,
    listColumn: any,
    exceptionColumnItem: Array<string> = []
  ) {
    const noHeaderName: any = [];
    for (const index in listColumn) {
      const searchItem: any = listColumn[index];
      let setHeaderItem: any;
      Object.keys(listInputField.fields).forEach(key => {
        // 振替・仕入単位の項目がある場合に合計となる振替・仕入金額(参照用も含む)、、営業利益、利益率を表示する為、
        // 例外リスト表示項目を追加する際に追加済のチェックを行い、存在しない場合は追加する
        if ('transfer_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_transfer_unit_price')) {
            exceptionColumnItem.push('reference_transfer_unit_price');
          }
          if (!exceptionColumnItem.includes('transfer_amount_price')) {
            exceptionColumnItem.push('transfer_amount_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        } else if ('purchase_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_purchase_unit_price')) {
            exceptionColumnItem.push('reference_purchase_unit_price');
          }
          if (!exceptionColumnItem.includes('purchasing_price')) {
            exceptionColumnItem.push('purchasing_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        }

        if (listInputField.fields[key].display_id === listColumn[index].value) {
          setHeaderItem = listColumn[index];
          return;
        }
      });

      if (setHeaderItem === undefined) {
        // トランやマスタに入っていない
        const exceptionItem = exceptionColumnItem.find(function(item) {
          if (searchItem.value === item) {
            return item;
          }
        });

        if (exceptionItem === undefined) {
          noHeaderName.push(listColumn[index].value);
        }
      }
    }
    for (const index in noHeaderName) {
      const searchIndex = listColumn.findIndex(function(item: any) {
        if (item.value === noHeaderName[index]) {
          return item;
        }
      });
      if (searchIndex !== -1) {
        listColumn.splice(searchIndex, 1);
      }
    }
  }

  private masterSelectEventRelay(response: any) {
    // 商材マスタ参照の選択時、ダイヤログのクローズは親コンポーネントで行う
    const masterSelectDataCommodity = this.masterSelectDataCommodity;
    // 商材マスタ参照の選択時、ダイヤログのローディング表示を行う
    this.$set(masterSelectDataCommodity, 'isLoadingFlag', true);
    try {
      // 商材マスタから選択された商材を構成明細に表示する
      if (this.partsListData.length !== 0) {
        this.partsListData = [];
        this.$set(this.partsList.tableParameters, 'body', []);
        // 登録データも初期化
        this.RegistMaterialTempleteDataList = [];
      }
      const commodityItem = this.masterCommoditySelectData.find(function(recode: any) {
        if (recode.i_id === response.value) {
          return recode;
        }
      });
      if (commodityItem !== undefined) {
        this.registData.item['commodity_id'] = commodityItem['i_id'];
      }
      const selectItemResult = this.masterData['m_material'].body.filter(function(recode) {
        if (commodityItem?.commodity === recode.commodity_id) {
          return recode;
        }
      });

      // ボタン設定を追加
      this.partsList.tableParameters.buttonItems = MaterialTemplateListDisplayButtonItems;

      for (let index = 0; index < selectItemResult.length; index++) {
        const materialElement = selectItemResult[index];
        const baseItems: any = {};
        const tepNo = Number(index) + 1;
        this.$set(baseItems, 'No', tepNo);
        this.$set(baseItems, 'quantity', 0);
        this.$set(baseItems, 'item', materialElement['item']);
        this.$set(baseItems, 'item_code', materialElement['item_code']);
        this.$set(baseItems, 'model_number', materialElement['model_number']);
        this.$set(baseItems, 'standard_unit_price', materialElement['standard_unit_price']);
        this.$set(baseItems, 'classification_id', materialElement['classification_id']);
        this.$set(baseItems, 'type_id', materialElement['type_id']);
        this.$set(baseItems, 'commodity_id', materialElement['commodity_id']);
        this.$set(baseItems, 'refrev_no', materialElement['rev_no']);
        this.$set(baseItems, 'transfer_unit_price', materialElement['transfer_unit_price']);
        this.$set(baseItems, 'material_id', materialElement['i_id']);

        this.$set(baseItems, 'quantity_lower_limit', 0);
        this.$set(baseItems, 'quantity_upper_limit', 0);
        this.$set(baseItems, 'unit_lower_limit', 0);
        this.$set(baseItems, 'unit_upper_limit', 0);

        // 編集可で設定
        this.$set(baseItems, 'edit_price_flag', '');
        this.$set(materialElement, 'edit_price_flag', 'false');
        this.$set(baseItems, 'edit_material_flag', '');
        this.$set(materialElement, 'edit_material_flag', 'false');

        this.partsListData.push(baseItems);

        // 登録用データの初期化
        const registItemsList: RegistMaterialTempleteData = {
          No: tepNo,
          id: 0,
          quantity: 0,
          quantity_lower_limit: 0,
          quantity_upper_limit: 0,
          unit_lower_limit: 0,
          unit_upper_limit: 0,
          refitem: materialElement['item'],
          refitem_code: materialElement['item_code'],
          refmodel_number: materialElement['model_number'],
          refrev_no: Number(materialElement['rev_no']),
          material_id: materialElement['i_id'],
          edit_price_flag: 'true',
          edit_material_flag: 'true'
        };
        this.RegistMaterialTempleteDataList.push(registItemsList);
      }

      this.$set(this.partsList.tableParameters, 'body', this.partsListData);
    } catch (e) {
      this.setError(e);
    } finally {
      if (masterSelectDataCommodity.isParentDialogControlFlag === true) {
        // 商材マスタ参照の選択時、ダイヤログのクローズは親コンポーネントからダイヤログ閉じる
        setTimeout(() => {
          this.$set(masterSelectDataCommodity, 'isLoadingFlag', false);
        }, Number(this.partsList.tableParameters.body.length * 25));
      }
    }
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * 明細リスト更新時
   */
  private getDataRelay(response: any) {
    if (
      response['itemIndex'] !== undefined &&
      response['inputName'] !== undefined &&
      response['inputName'] === 'quantity' ||
      response['inputName'] === 'quantity_lower_limit' ||
      response['inputName'] === 'quantity_upper_limit' ||
      response['inputName'] === 'unit_lower_limit' ||
      response['inputName'] === 'unit_upper_limit' &&
      response['inputValue'] !== undefined
    ) {
      const rindex: number = Number(response['itemIndex']) + 1;
      const findex: number = this.RegistMaterialTempleteDataList.findIndex(v => v.No === rindex);
      const Setquantity: number =
        response['inputValue'] !== '' ? Number(response['inputValue']) : 0;

      if (response['inputName'] === 'quantity') {
        if (findex !== -1) {
          this.$set(this.partsListData[response.itemIndex], 'quantity', Setquantity);
          this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity', Setquantity);
        }
      }
      if (response['inputName'] === 'quantity_lower_limit') {
        if (findex !== -1) {
          this.$set(this.partsListData[response.itemIndex], 'quantity_lower_limit', Setquantity);
          this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_lower_limit', Setquantity);
        }
      }
      if (response['inputName'] === 'quantity_upper_limit') {
        if (findex !== -1) {
          this.$set(this.partsListData[response.itemIndex], 'quantity_upper_limit', Setquantity);
          this.$set(this.RegistMaterialTempleteDataList[findex], 'quantity_upper_limit', Setquantity);
        }
      }
      if (response['inputName'] === 'unit_lower_limit') {
        if (findex !== -1) {
          this.$set(this.partsListData[response.itemIndex], 'unit_lower_limit', Setquantity);
          this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_lower_limit', Setquantity);
        }
      }
      if (response['inputName'] === 'unit_upper_limit') {
        if (findex !== -1) {
          this.$set(this.partsListData[response.itemIndex], 'unit_upper_limit', Setquantity);
          this.$set(this.RegistMaterialTempleteDataList[findex], 'unit_upper_limit', Setquantity);
        }
      }
    }
  }

  private clickButton(response: any) {
    switch (response.buttonName) {
      // todo 金額変更の処理も追加
      case "edit_price_flag": {
        if (response.record.edit_price_flag !== '') {
          // 編集可
          this.$set(this.partsListData[response.itemIndex], 'edit_price_flag', '');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_price_flag', 'true');
        } else {
          // 編集不可
          this.$set(this.partsListData[response.itemIndex], 'edit_price_flag', 'false');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_price_flag', 'false');
        }
        break;
      }
      case "edit_material_flag": {
        if (response.record.edit_material_flag !== '') {
          // 編集可
          this.$set(this.partsListData[response.itemIndex], 'edit_material_flag', '');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_material_flag', 'true');
        } else {
          // 編集不可
          this.$set(this.partsListData[response.itemIndex], 'edit_material_flag', 'false');
          this.$set(this.RegistMaterialTempleteDataList[response.itemIndex], 'edit_material_flag', 'false');
        }
        break;
      }
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    /** 停止フラグ **/
    let StpFlg = false;

    switch (type) {
      case 'register':
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          // 重複チェックを実施する
          StpFlg = await this.isDuplicated();
          if (!StpFlg) {
            // 明細を関連データ部にセット
            const reglistSetter = await this.addRelatedDsItem(this.RegistMaterialTempleteDataList);
            this.$set(this.registData.related_ds_items, this.subDsId, reglistSetter);

            const result = await this.materialTemplate.registerLinkedItems(
              hexabaseState.applicationId,
              this.mainDsId,
              this.registData
            );
            this.materialTemplate.apiErrorHandle('CREATEITEM', result);
            this.registerText = this.materialTemplate.deepCopy(registerFinishText);
            this.buttons.map(v => {
              if (v.name === 'toEdit') {
                v.route = String(v.route).replace(':id', result.item_id);
              }
            });
          }
        } catch (e) {
          console.log(e);
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          if (!StpFlg) {
            this.dialogStatus = true;
          } else {
            this.isExecDialog = true;
          }
        }
        break;
      case 'cancel': {
        const beforeRoute = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };
        if (this.prevRoute && this.prevRoute.name !== null && this.prevRoute.name !== '') {
          this.$router.push(beforeRoute);
        } else {
          this.$router.push({ name: 'Portal' });
        }
      }
    }
  }

  /**
   * 関連データの整形
   * @param {Array<RegistMaterialTempleteData>} - 登録データ
   */
  private async addRelatedDsItem(regList: Array<RegistMaterialTempleteData>) {
    const retunArray: any = [];

    if (regList.length > 0) {
      regList.forEach(regElements => {
        const RegistMaterialTempleteitem: RegistMaterialTempleteExec = {
          materialtemplate_id: '',
          material_id: regElements.material_id,
          quantity: regElements.quantity,
          quantity_lower_limit: regElements.quantity_lower_limit,
          quantity_upper_limit: regElements.quantity_upper_limit,
          unit_lower_limit: regElements.unit_lower_limit,
          unit_upper_limit: regElements.unit_upper_limit,
          ref_rev_no: regElements.refrev_no,
          ref_item: regElements.refitem,
          ref_item_code: regElements.refitem_code,
          ref_model_number: regElements.refmodel_number,
          edit_price_flag: regElements.edit_price_flag,
          edit_material_flag: regElements.edit_material_flag,
          sort_no: regElements.No
        };
        retunArray.push({
          operation: 1,
          link_to_parent: true,
          item: RegistMaterialTempleteitem
        });
      });
    }
    return retunArray;
  }

  /**
   * 重複判定部
   * 「顧客名」「電話番号」の組み合わせで重複判定を行う
   * @returns {boolean} 重複有りの場合true
   */
  private async isDuplicated() {
    const alreadyData = this.masterData.m_materialtemplate.body.findIndex(
      v => v.template_name === this.registData.item['template_name'] && v.Status === '有効'
    );
    if (alreadyData !== undefined && alreadyData !== -1) {
      this.isDuplicateId = this.masterData.m_materialtemplate.body[alreadyData].i_id;
      return true;
    } else {
      return false;
    }
  }

  /** ダイアログ処理 */
  private async clearExecDialog(response: any): Promise<boolean> {
    this.isExecDialog = false;
    if (response !== undefined && response.isAgree) {
      // 編集へ遷移
      this.$router.push({ name: 'MaterialTemplateEdit', params: { id: this.isDuplicateId } });
    }
    return true;
  }

  /*******************************************************************************/

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  /**
   * エラー情報の処理
   * @param {string} - エラー情報文字列
   */
  private setError(errorMessage: any) {
    if (typeof errorMessage === 'object')
      errorMessage = this.materialTemplate.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }
}
